import api from './axios';

/**
 * Fetch paginated and filtered audit logs
 * @param {Object} params - Query parameters (page, per_page, search, module, etc.)
 */
export const getAuditLogs = (params = {}) => {
  return api.get('/api/v1/audit-logs', { params });
};

/**
 * Download exported audit logs as CSV
 * @param {Object} params - Query parameters for filtering the export
 */
export const exportAuditLogs = async (params = {}) => {
  try {
    const response = await api.get('/api/v1/audit-logs/export', { 
      params,
      responseType: 'blob' 
    });
    
    // Create download link for the blob
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `audit_logs_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    return true;
  } catch (error) {
    console.error('Export failed:', error);
    throw error;
  }
};
